import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedPipesModule } from '../../shared-pipes/shared-pipes.module';
import { LoaderModule } from '../../loader/loader.module';
import { TooltipComponent } from './tooltip.component';
import { TooltipDirective } from './tooltip.directive';



@NgModule({
  declarations: [
    TooltipComponent,
    TooltipDirective
  ],
  imports: [
    CommonModule,
    SharedPipesModule,
    LoaderModule
  ],
  exports: [
    TooltipComponent,
    TooltipDirective
  ]
})
export class TooltipModule { }
